import { TargetLocalesSelect } from '~/components/common/target-locales-select';
import { useCanTranslateContent } from '~/hooks/useCanTranslateContent';

interface TargetLocalesSectionProps {
  value: string[];
  onChange: (locales: string[]) => void;
  disabled?: boolean;
  /** `data-testid` forwarded to the locales select. */
  testId?: string;
}

/**
 * The panel's languages row, in the same bordered section style as its siblings. Renders nothing
 * (not even the border) for users who cannot translate, so their panel is unchanged.
 */
export function TargetLocalesSection({
  value,
  onChange,
  disabled,
  testId,
}: TargetLocalesSectionProps) {
  const canTranslate = useCanTranslateContent();
  if (!canTranslate) return null;
  return (
    <div
      className="border-t px-6 py-5"
      data-testid={testId ? `${testId}-section` : 'target-locales-section'}
    >
      <TargetLocalesSelect
        idPrefix="enrichment-run-locale"
        value={value}
        onChange={onChange}
        {...(disabled !== undefined ? { disabled } : {})}
        {...(testId !== undefined ? { testId } : {})}
      />
    </div>
  );
}
